import React from 'react';
import {motion} from 'framer-motion';
import {Ban, ChevronRight, ShieldCheck, Sparkles, Tv, Wifi, Zap} from 'lucide-react';
import {Link} from 'react-router-dom';

const highlights = [
    {icon: Tv, text: 'Blokada reklam na Smart TV i telefonach'},
    {icon: Wifi, text: 'Działa automatycznie w całym Wi-Fi'},
    {icon: ShieldCheck, text: 'Ochrona dla dzieci i kontrola treści'},
    {icon: Zap, text: 'Szybszy internet bez zbędnego transferu'},
];

export function AdBlockBanner() {
    return (
        <section className="w-full px-5 py-12 md:py-16 bg-background">
            <div className="max-w-6xl mx-auto">
                <motion.div
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.5}}
                    className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary via-primary-dark to-purple-900 p-8 md:p-12 text-white shadow-xl shadow-primary/10"
                >
                    <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/10 blur-3xl pointer-events-none"/>
                    <div className="absolute -bottom-16 -left-16 w-64 h-64 rounded-full bg-white/10 blur-3xl pointer-events-none"/>

                    <div className="relative flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">
                        <div className="flex-1">
                            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/15 backdrop-blur-md text-xs md:text-sm font-semibold mb-4">
                                <Sparkles size={14}/> Anty-reklama Wi-Fi - Mielec i okolice do 250 km
                            </div>
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight mb-3">
                                Anty-reklama na Twoją sieć Wi-Fi w domu - pozbądź się reklam!
                            </h2>
                            <p className="text-white/85 max-w-2xl mb-6 text-sm md:text-base leading-relaxed">
                                Konfigurujemy cichy, energooszczędny mikrokomputer (mikroPC), który filtruje ruch w całej domowej sieci Wi-Fi. 
                                <strong> Reklamy, wyskakujące okienka i trackery znikają automatycznie ze Smart TV, smartfonów, tabletów i laptopów</strong> - bez instalowania jakichkolwiek wtyczek czy aplikacji na urządzeniach domowników.
                            </p>

                            <div className="grid sm:grid-cols-2 gap-x-6 gap-y-3 mb-8">
                                {highlights.map((h) => {
                                    const Icon = h.icon;
                                    return (
                                        <div key={h.text} className="flex items-center gap-2.5 text-sm font-medium text-white/95">
                                            <div className="w-6 h-6 rounded-md bg-white/15 flex items-center justify-center shrink-0">
                                                <Icon size={14} className="text-white"/>
                                            </div>
                                            {h.text}
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="flex flex-wrap items-center gap-4">
                                <Link
                                    to="/blokada-reklam"
                                    className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-white text-primary font-bold text-sm md:text-base hover:bg-white/90 hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-black/10"
                                >
                                    Pozbądź się reklam w Wi-Fi <ChevronRight size={18}/>
                                </Link>
                                <span className="text-xs text-white/70">
                                    Montaż i konfiguracja na miejscu lub gotowy zestaw Plug&Play
                                </span>
                            </div>
                        </div>

                        <div className="hidden lg:flex shrink-0 items-center justify-center w-36 h-36 rounded-3xl bg-white/10 border border-white/20 backdrop-blur-md shadow-2xl">
                            <Ban size={64} className="text-white animate-pulse"/>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
